// extracted by mini-css-extract-plugin
module.exports = {"cookieConsentBanner":"_cookie_cookieConsentBanner__jUkxQ","okButton":"_cookie_okButton__BqwRN","okButton2":"_cookie_okButton2___hA3n"};